<template>
  <div>
    <div class="goback-large" style="font-size:17px;">
      <i class="fal fa-arrow-left c-pointer" @click="clickBackButton"></i> 역할 별 권한 범위
    </div>
    <div class="title-bar">
      WatchAll은 어드민, 관리자, 사용자 등 총 3가지의 역할을 제공합니다.
    </div>
    <el-table-wrapper class="mr-b25" :data="tableData" :columns="tableColumns" :column-default="columnDefault" :pagination="false" style="width:100%;">
    </el-table-wrapper>
    <div class="title-h4 title-bar">
      권한 범위 설명
    </div>
    <ul>
      <li>모니터링 : 할당된 장비 및 그룹에 대한 관제 정보를 모니터링 할 수 있는 권한</li>
      <li>액션 : 할당된 장비 및 그룹에 대해 실제 다양한 기능을 수행할 수 있는 권한</li>
      <li>개별설정 : 할당된 장비 및 그룹에 대해 각 개별 설정을 수정할 수 있는 권한</li>
      <li>공통설정 : 관제 범위에 있는 모든 장비 및 WatchAll 운영에 대한 설정을 수행할 수 있는 권한</li>
    </ul>
  </div>
</template>

<script>
import { columnDefault } from '@/constants/table';

export default {
  name: 'WManagerTypeInfo',
  data() {
    return {
      columnDefault,
      tableColumns: [
        { prop: 'type' },
        { prop: 'admin', label: '어드민' },
        { prop: 'manager', label: '관리자' },
        { prop: 'user', label: '사용자' },
      ],
      tableData: [
        { type: '모니터링', admin: 'All', manager: '할당된 장비 및 그룹', user: '할당된 장비 및 그룹' },
        { type: '액션', admin: 'All', manager: '할당된 장비 및 그룹', user: '-' },
        { type: '개별설정', admin: 'All', manager: '할당된 장비 및 그룹', user: '-' },
        { type: '공통설정', admin: 'All', manager: '-', user: '-' },
      ],
    };
  },
  methods: {
    clickBackButton() {
      this.$emit('click-back-button');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/components/ManagerTypeInfo.vue